export const TenantSettingKeys = {
  CompanyName: 'UI-SERVERLESS.PUBLIC.NAME',
  OrderLinePrefix: 'UI-SERVERLESS.PUBLIC.ORDERLINEPREFIX',
  CurrencyCode: 'UI-SERVERLESS.PUBLIC.CURRENCY',
  BaseURL: 'UI-SERVERLESS.PUBLIC.BASEURL',
  Website: 'UI-SERVERLESS.PUBLIC.WEBSITE',
  InvoiceApi: 'UI-SERVERLESS.PUBLIC.USEINVOICEAPI',
  Links: {
    Tracking: 'UI-SERVERLESS.PUBLIC.LINKS.TRACKING'
  }
};
